import { render, staticRenderFns } from "./bid-line-details-modal.vue?vue&type=template&id=38cc04a3&scoped=true"
import script from "./bid-line-details-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./bid-line-details-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bid-line-details-modal.vue?vue&type=style&index=0&id=38cc04a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc04a3",
  null
  
)

export default component.exports